import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'María G.',
  age: '68 años',
  role: 'Maestra jubilada',
  text: 'Antes me daba miedo levantarme del sofá si no tenía la mesita cerca. Ahora siento que mis piernas me responden. Son ejercicios tan sencillos que no creí que funcionaran, pero la constancia de 7 minutos al día me cambió la vida.',
  rating: 5
}, {
  id: 2,
  name: 'Carmen R.',
  age: '72 años',
  role: 'Abuela de 4 nietos',
  text: 'Ya no voy tocando las paredes del pasillo cuando voy a la cocina. Mis hijos me dicen que camino más erguida. Lo mejor es que no me canso, al contrario, termino con más energía.',
  rating: 5
}, {
  id: 3,
  name: 'Lourdes M.',
  age: '66 años',
  role: 'Recién jubilada',
  text: 'Nunca fui de gimnasios y menos ahora. Esta guía es perfecta porque la hago en pijama antes del desayuno. Me siento segura y ágil, como hace 10 años no me sentía.',
  rating: 5
}, {
  id: 4,
  name: 'Patricia S.',
  age: '70 años',
  role: 'Vive sola',
  text: 'Vivir sola a mi edad da miedo por las caídas. Esta guía me devolvió la confianza. Ya no pienso en "cuidado no te caigas" a cada paso, simplemente camino y disfruto mi casa.',
  rating: 5
}, {
  id: 5,
  name: 'Elena V.',
  age: '74 años',
  role: 'Con dolor de rodilla',
  text: 'Tengo artrosis y pensaba que no podría. Pero las modificaciones para rodilla son una bendición. Puedo hacer todo sin dolor y siento mis piernas mucho más fuertes.',
  rating: 5
}];
export function Testimonials() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-16 px-6 max-w-3xl mx-auto bg-[#FDF8F0]" data-id="element-173">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={containerVariants} className="space-y-12" data-id="element-174">
        <div className="text-center space-y-4" data-id="element-175">
          <motion.h2 variants={itemVariants} className="font-serif text-3xl md:text-4xl font-bold text-[#2A6B6B]" data-id="element-176">
            Lo que dicen quienes ya lo usan
          </motion.h2>
          <motion.p variants={itemVariants} className="text-lg text-[#5C544E] max-w-xl mx-auto" data-id="element-177">
            Mujeres reales recuperando su confianza, paso a paso.
          </motion.p>
        </div>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-178">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} variants={itemVariants} className={`bg-white p-6 rounded-2xl shadow-sm border border-[#E8DDD0] relative ${index === testimonials.length - 1 ? 'md:col-span-2 md:w-2/3 md:mx-auto' : ''}`} data-id="element-179">
              <Quote className="absolute top-6 right-6 text-[#E8DDD0]/50 h-10 w-10 rotate-180" data-id="element-180" />

              <div className="flex gap-1 mb-4" data-id="element-181">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="h-5 w-5 fill-[#D4654A] text-[#D4654A]" data-id="element-182" />)}
              </div>

              <p className="text-[#3D3631] text-lg leading-relaxed mb-6 font-medium italic" data-id="element-183">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-3 border-t border-[#E8DDD0] pt-4" data-id="element-184">
                <div className="h-10 w-10 rounded-full bg-[#8BAA8B]/20 flex items-center justify-center text-[#2A6B6B] font-bold font-serif" data-id="element-185">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-186">
                  <p className="font-bold text-[#2A6B6B] text-sm" data-id="element-187">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="text-[#5C544E] text-xs uppercase tracking-wide" data-id="element-188">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}